import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { Component } from 'react'; // eslint-disable-line
import { Link } from 'react-router-dom';
import constants from '../../constants';

class ErrorAlert extends Component {
    constructor(props) {
        super(props);

        this.hideAlert = this.hideAlert.bind(this);
    }

    hideAlert() {
        this.props.clearAlert(this.props.alertId);
    }

    render() {
        let {
            message,
            dismissable,
            alertClass,
            link,
            clearable,
            clearAction,
            linkText,
        } = this.props;

        alertClass = alertClass || 'error';

        let icon = '';
        let closeIcon = '';
        switch (alertClass) {
            case 'success':
                icon = <FontAwesomeIcon icon={['fas', 'check']} color={constants.StyleColors.successDark} />;
                closeIcon = <FontAwesomeIcon icon={['fal', 'times']} color={constants.StyleColors.successDark} />;
                break;
            case 'info':
                icon = <FontAwesomeIcon icon={['fas', 'smile']} color={constants.StyleColors.infoDark} />;
                closeIcon = <FontAwesomeIcon icon={['fal', 'times']} color={constants.StyleColors.infoDark} />;
                break;
            case 'error':
                icon = <FontAwesomeIcon icon={['fas', 'times-circle']} color={constants.StyleColors.error2} />;
                closeIcon = <FontAwesomeIcon icon={['fal', 'times']} color={constants.StyleColors.error2} />;
                break;
            case 'warning':
                icon = <FontAwesomeIcon icon={['fas', 'exclamation-triangle']} color={constants.StyleColors.warningDark} />;
                closeIcon = <FontAwesomeIcon icon={['fal', 'times']} color={constants.StyleColors.warningDark} />;
                break;
            default:
                icon = '';
                break;
        }

        let dismissButton = '';
        if (dismissable) {
            dismissButton = (
                // eslint-disable-next-line
                <a className="close-message" aria-label="Close Alert" onMouseUp={this.hideAlert}>
                    {closeIcon}
                </a>
            );
        }
        if (clearable) {
            dismissButton = (
                // eslint-disable-next-line
                <a className="close-message" onClick={clearAction}>
                    {closeIcon}
                </a>
            );
        }

        const showLink = link && typeof link === 'string' && linkText;
        return (typeof message === 'string' ? (
            <div className="alert-container">
                <div className={`alert ${alertClass}`}>
                    <span>{icon}</span>
                    <p className="alert-message">
                        {`${message}\xa0`}
                        {showLink ? (<Link to={link}>{linkText}</Link>) : ''}
                    </p>
                    {dismissButton}
                </div>
            </div>
        ) : <div />
        );
    }
}

export default ErrorAlert;
